const modal = () => {
  const cookieName = 'made_in_canada_popup_closed';
  const cookieDuration = 259200;
  const buttonTriggers = document.querySelectorAll('.js-cookie-trigger');
  const modalOverlay = document.querySelector('.modal-overlay');

  if (!modalOverlay) return;

  MicroModal.init();

  if (!document.cookie.includes(cookieName)) {
    setTimeout(() => {
      MicroModal.show('popup');
    }, 2000);
  }

  const closeModalAndSetCookie = () => {
    document.cookie = `${cookieName}=true; path=/; max-age=${cookieDuration}`;
    Promise.resolve().then(() => MicroModal.close('popup'));
  };

  buttonTriggers.forEach(btn => {
    btn.addEventListener('click', closeModalAndSetCookie);
    if (btn.tagName == 'DIV') return;
    btn.addEventListener('touchend', closeModalAndSetCookie);
  });

  modalOverlay.addEventListener('click', (e) => {
    console.log(e.target);
    if (e.target === modalOverlay) closeModalAndSetCookie();
  });

  modalOverlay.addEventListener('touchend', (e) => {
    console.log(e.target);
    if (e.target === modalOverlay) closeModalAndSetCookie();
  });
};

export default modal;
